  <form [formGroup]="authChannelForm">
    <div class="social-account-item d-flex" [ngClass]="{'unauthorize': isUnAuthorize}">
      <div class="social-input">
        <div>
          <div class="social-icon {{platformSetting.platform}}-icon"></div>
        </div>

        <div class="social-input-field">
          <achoo-text-field [(model)]="platformSetting.account"
                            (modelChange)="onHandleChange($event)"
                            [disabled]="isDisabled"
                            [showError]="false"
                            name="{{fieldName()}}">
          </achoo-text-field>
        </div>

      </div>
      <div class="social-action d-flex">
        <div *ngIf="isReAuthorize && isIGChannel" class="status clickable">
          <div class="flex-auto">{{'influencer_settings.status.reauthorize' | translate}}</div>
        </div>
        <div *ngIf="isUnAuthorize" class="status danger clickable" (click)="onAuthorize()">
          <div class="flex-auto">{{unauthorizeButtonLabel}}</div>
        </div>
        <div *ngIf="isAuthorized" class="status success">
          <div class="flex-auto">{{authorizedButtonLabel | translate}}</div>
          <div class="channel-confirm-status-icon" *ngIf="isConfirming">
            <achoo-loader [normalPlaceholder]="true"></achoo-loader>
          </div>
        </div>
        <div *ngIf="isError" class="status error clickable" (click)="reAuthorize()">
          <div class="flex-auto">{{reAuthorizeButtonLabel}}</div>
        </div>

        <a class="d-none d-sm-block" (click)="deleteChannel(channelData, false)">
          <div class="close icon-close"><img src="./assets/images/Delete_Dark.svg" alt="" width="16" height="16" /></div>
        </a>

        <a class="d-block d-sm-none" (click)="deleteChannel(channelData, true)">
          <div class="close icon-close"><img src="./assets/images/Delete_Dark.svg" alt="" width="16" height="16" /></div>
        </a>
        <div *ngIf="platformSetting.alert" class="alert">{{'influencer_settings.status.lost' | translate}}</div>
      </div>
    </div>
  </form>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-settings/platform-field/platform-field.component.html